import { FC, useContext, useEffect, useRef } from 'react';
import { useQuery } from '@tanstack/react-query'
import { Toolbar, ToolbarButton, Label, useId, Dialog, DialogTrigger, Button, DialogSurface, DialogTitle, DialogBody, DialogContent, DialogActions } from '@fluentui/react-components';
import 'ckeditor5/ckeditor5.css';
import './JobsEdit.css';
import Editor from './Editor';
// import { CKEditor, useCKEditorCloud } from '@ckeditor/ckeditor5-react';
// import type { EditorConfig } from '@ckeditor/ckeditor5-core/src/editor/editorconfig';
// import { ClassicEditor } from '@ckeditor/ckeditor5-editor-classic/dist/index.js';
// import { Bold, Italic, Superscript, Subscript, Underline } from '@ckeditor/ckeditor5-basic-styles/dist/index.js';
// import { Heading } from '@ckeditor/ckeditor5-heading/dist/index.js';
// import { Link, AutoLink } from '@ckeditor/ckeditor5-link/dist/index.js';
// import { Paragraph } from '@ckeditor/ckeditor5-paragraph/dist/index.js';
// import { Undo } from '@ckeditor/ckeditor5-undo/dist/index.js';
// import { List } from '@ckeditor/ckeditor5-list/dist/index.js';
// import { Essentials } from '@ckeditor/ckeditor5-essentials/dist/index.js';
//import { ClassicEditor, Bold, Essentials, Italic, Mention, Paragraph, Undo, Superscript, Subscript, Underline, Link, AutoLink, List, Heading  } from 'ckeditor5';
import { bind } from '@react-rxjs/core';
import { accessTokenInfo$, isAuthorized$ } from '../oauth/oauth';
import { nodeServer } from '../constants';
import { useNavigate,  useParams } from 'react-router-dom';
import IJob from './IJob';
import { DatePicker } from '@fluentui/react-datepicker-compat';
// import { EventInfo } from 'ckeditor5';
import { ToastContext } from '../context/ToastContext';
import { Controller, useForm } from 'react-hook-form';
import FormInput from '../utility/FormInput';
//import type { ClassicEditor } from 'ckeditor5';
import  Quill from 'quill';


interface JobsProps {

}

const [useIsAuthorized] = bind(isAuthorized$, isAuthorized$.value);

 //const Delta = Quill.import('delta');

const JobsEdit: FC<JobsProps> = () => {
   // const editorContainerRef = useRef(null);
    //const editorRef = useRef<CKEditor<ClassicEditor>>(null);
//    const [isLayoutReady, setIsLayoutReady] = useState(false);
    //const cloud = useCKEditorCloud({ version: '44.1.0' });

    // useEffect(() => {
    //     setIsLayoutReady(true);

    //     return () => setIsLayoutReady(false);
    // }, []);

   const quillRef = useRef<Quill>();

    // const { ClassicEditor, editorConfig } = useMemo(() => {
    //     if (cloud.status !== 'success' || !isLayoutReady) {
    //         return {};
    //     }

    //     const { ClassicEditor, AutoLink, Bold, Essentials, Italic, Link, Paragraph, Undo, Superscript, Subscript, Underline, List, Heading } = cloud.CKEditor;

    //     const editorConfig: EditorConfig = {
    //         toolbar: {
    //             items: ['undo', 'redo', '|', 'heading', 'bold', 'italic', 'underline', 'superscript', 'subscript', '|', 'link', 'bulletedList', 'numberedList'],
    //         },
    //         plugins: [
    //             Bold, Italic, Paragraph, Undo, Superscript, Subscript, Underline, Link, AutoLink, List, Heading, Essentials
    //         ],
    //         initialData:
    //             '',
    //         licenseKey: ckeditorLicenseKey,
    //         link: {
    //             addTargetToExternalLinks: true,
    //             defaultProtocol: 'https://',
    //             decorators: {
    //                 toggleDownloadable: {
    //                     mode: 'manual',
    //                     label: 'Downloadable',
    //                     attributes: {
    //                         download: 'file'
    //                     }
    //                 }
    //             }
    //         },
    //         placeholder: 'Type or paste your content here!'
    //     };
    //     return {
    //         ClassicEditor,
    //         editorConfig
    //     };
    // }, [cloud, isLayoutReady]);

    const { jobId } = useParams();

    const { data: jobEdit, refetch } = useQuery({
        queryKey: ['jobEdit'],
        refetchOnWindowFocus: false,
        queryFn: async () => {
            if (jobId !== "new") {
                if (accessTokenInfo$.value === null || accessTokenInfo$.value.accessToken === null) {
                    return undefined;
                }
                let headers = new Headers();
                headers.append('Content-Type', 'application/json');
                headers.append('Authorization', 'Bearer ' + accessTokenInfo$.value.accessToken);
                let url = nodeServer + `jobs/` + jobId;
                const res = await fetch(url, { headers: headers });
                if (!res.ok) {
                    throw new Error('Network response was not ok')
                }
                const job: IJob = await res.json();
                job.expiration = new Date(Date.parse(job.expiration as string));
                job.created = new Date(Date.parse(job.created as string));

                return job;
            }
        }
    });


    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm<IJob>({
        mode: "onChange",
        //resetOptions: { keepDefaultValues: true },
        // values: editedValues,
        defaultValues: {
            title: '',
            content: '',
            link: '',
            expiration: new Date(),
            created: new Date(),
        },

    });

    useEffect(() => {
        try{
            var parsedContent = JSON.parse(jobEdit?.content!);
            quillRef.current?.setContents(parsedContent);
        } catch (e) {
        }
        //editorRef.current?.editor?.setData(jobEdit?.content as string);
        reset(jobEdit);
    }, [jobEdit]);


    const isAuthorized = useIsAuthorized();
    const toastContext = useContext(ToastContext);
    const navigate = useNavigate();
    const expirationId = useId('expirationId');

    const onSave = async (data: IJob) => {
        if (accessTokenInfo$.value === null || accessTokenInfo$.value.accessToken === null) {
            toastContext.notifyError("You're not logged in.  Cannot save.  If you think you're logged in, try logging out then back in using the top right button.")
            return;
        }
        data.content = JSON.stringify(quillRef.current?.getContents());
        //data.content = editorRef.current?.editor?.getData() as string;
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + accessTokenInfo$.value.accessToken);
        if (jobId === 'new') {
            let url = nodeServer + `jobs`;
            const res = await fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(data) });
            const result = await res.json();
            if (!res.ok) {
                toastContext.notifyError(result.error);
            } else {
                toastContext.notifySuccess(result.message);
                navigate(`/jobs/edit/${result.job.id}`);
            }
        } else {
            let url = nodeServer + `jobs/` + jobId;

            const res = await fetch(url, { method: 'PUT', headers: headers, body: JSON.stringify(data) });
            const result = await res.json();
            if (!res.ok) {
                toastContext.notifyError(result.error);
            } else {
                toastContext.notifySuccess(result.message);
                refetch();
            }
        }
    }

    const onDelete = async () => {
        if (accessTokenInfo$.value === null || accessTokenInfo$.value.accessToken === null) {
            toastContext.notifyError("You're not logged in.  Cannot delete.  If you think you're logged in, try logging out then back in using the top right button.")
            return;
        }
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + accessTokenInfo$.value.accessToken);
        let url = nodeServer + `jobs/` + jobId;

        const res = await fetch(url, { method: 'DELETE', headers: headers });
        const result = await res.json();
        if (!res.ok) {
            toastContext.notifyError(result.error)
        } else {
            toastContext.notifySuccess('Your job posting was successfully deleted!');
            navigate(-1);
        }
    };


    return (
        <>
            {isAuthorized ? (
                <>

                    <div style={{ height: '100%', overflow: 'auto' }}>
                        <form onSubmit={handleSubmit(onSave)} method="POST">
                            <Toolbar >
                                <ToolbarButton appearance='primary' type='submit'>Save</ToolbarButton>
                                <Dialog>
                                    <DialogTrigger disableButtonEnhancement>
                                        <ToolbarButton appearance='subtle' style={{ color: 'red' }} >Delete</ToolbarButton>
                                    </DialogTrigger>
                                    <DialogSurface>
                                        <DialogBody>
                                            <DialogTitle>Delete Job Listing?</DialogTitle>
                                            <DialogContent>
                                                <p>If you delete this listing, it will be erased for good.  Are you sure you want to delete it? </p>
                                                <p>Alternatively, you can set the expiration to a past date and it will disappear from public view.</p>
                                            </DialogContent>
                                            <DialogActions>
                                                <DialogTrigger disableButtonEnhancement>
                                                    <Button appearance="secondary">Cancel</Button>
                                                </DialogTrigger>
                                                <DialogTrigger disableButtonEnhancement>
                                                    <Button appearance="primary" style={{ background: 'red' }} onClick={onDelete}>Delete</Button>
                                                </DialogTrigger>
                                            </DialogActions>

                                        </DialogBody>
                                    </DialogSurface>
                                </Dialog>

                            </Toolbar>

                            <div style={{ height: 'calc(100% - 40px)', overflow: 'auto', display: 'flex', flexDirection: 'column', rowGap: '5px', minWidth: 0 }} >

                                <FormInput size='large' label='Title' name='title' control={control} required={true} error={errors.title} />
                                <FormInput label='Link to Original Post or Application' name='link' control={control} required={true} error={errors.link} />

                                <Controller name="expiration" control={control} render={({ field }) => (
                                    <>
                                        <Label size='medium' htmlFor={expirationId} >Expiration</Label>
                                        <DatePicker size='medium' id={expirationId} value={field.value as Date} onSelectDate={(e) => { e && field.onChange(e) }} />
                                    </>
                                )}
                                />
                                {/* <Controller name='content' control={control} render={({ field }) => (<> */}
                                <Editor
                                    ref={quillRef}
                                    toolbar={true}
                                    // readOnly={false}
                                    //value={jobEdit?.content ? new Delta().insert(jobEdit.content) : new Delta()}
                                    // defaultValue={new Delta()}
                                    // .insert('Hello')
                                    // .insert('\n', { header: 1 })
                                    // .insert('Some ')
                                    // .insert('initial', { bold: true })
                                    // .insert(' ')
                                    // .insert('content', { underline: true })
                                    // .insert('\n')}
                                    />
                                {/* <div ref={editorContainerRef}>{ClassicEditor && editorConfig &&
                                    <CKEditor ref={editorRef} editor={ClassicEditor} config={editorConfig} />
                                }</div> */}
                                {/* </>)} /> */}



                            </div>
                        </form>
                    </div>
                </>
            ) : (
                <></>
            )}



            {/*  */}

        </>
    );
};

export default JobsEdit;
